import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BasicInput } from '@dev/ee-components';
import { debounce } from '@/services/tools/debounce';
import { checkIsUrlInvalid } from "@/services/tools/urlValidation/checkIsUrlInvalid";
import { checkKeyCombinations } from "@/services/tools/urlValidation/checkKeyCombinations";
import { Protocol } from "@/services/tools/urlValidation/types";
import { addHttpsToTargetValue } from "@/services/tools/urlValidation/addHttpsToTargetValue";
import { FormMultiDoubleOptInExternalWebsiteWrapper } from "./styles";
import { ModalStateAction, setDoubleOptInPageIsErrorAction, setDoubleOptInPageValueAction } from "../../state";

interface FormMultiDoubleOptInExternalWebsiteProps {
    doubleOptInPageValue?: string,
    isDoubleOptInPageError?: boolean,
    dispatchModalState: React.Dispatch<ModalStateAction<any>>,
}

export const FormMultiDoubleOptInExternalWebsite = ({
    doubleOptInPageValue,
    isDoubleOptInPageError,
    dispatchModalState
}: FormMultiDoubleOptInExternalWebsiteProps) => {
    const { t } = useTranslation();
    const [isInteracted, setIsInteracted] = useState(false);

    const modifyFormExternalUrl = (externalUrl: string): void => {
        dispatchModalState(setDoubleOptInPageValueAction(externalUrl));
    }

    const checkError = (externalUrl: string): void => {
        dispatchModalState(setDoubleOptInPageIsErrorAction(checkIsUrlInvalid(externalUrl)))
    }

    const changeExternalWebsiteInput = (ev): void => {
        const externalUrl = ev.target.value;
        modifyFormExternalUrl(externalUrl);
        
        debounce((): void => {
            checkError(externalUrl);
        });
    };

    const handleFirstKeyDownWebsite = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (isInteracted) return;
        const { isModifierPressed, isKeyCombination } = checkKeyCombinations(e);
        if (isKeyCombination) {
            setIsInteracted(true);
            return;
        }
        const target = e.target as HTMLInputElement;
        const autoUrl = addHttpsToTargetValue(target.value);
        if (!isModifierPressed && (!checkIsUrlInvalid(autoUrl) || !target.value.length) && e.key !== "Backspace") {
            modifyFormExternalUrl(autoUrl);
            setIsInteracted(true);
        }
    };

    const onWebsiteUrlInputBlur = (e: React.MouseEvent<Document>) => {
        const target = e.target as HTMLInputElement;
        const autoUrl = addHttpsToTargetValue(target.value);
        if (!checkIsUrlInvalid(autoUrl)) {
            modifyFormExternalUrl(autoUrl);
        }
        
        checkError(target.value);
        setIsInteracted(false);
    };

    return (
        <FormMultiDoubleOptInExternalWebsiteWrapper>
            <BasicInput
                id={'double-opt-in-external-website-input'}
                label={t('url')}
                onChange={changeExternalWebsiteInput}
                value={doubleOptInPageValue || ''}
                placeholder={Protocol.HTTPS}
                disableSentenceCase
                onKeyDown={handleFirstKeyDownWebsite}
                onBlur={onWebsiteUrlInputBlur}
                error={isDoubleOptInPageError}
                errorMessage={t('pleaseentervalidurl')}
            />
        </FormMultiDoubleOptInExternalWebsiteWrapper>
    )
}